import { ButtonBase, Stack } from '@razz-team/ui-web';
import { AppLogo } from '../../Logo/AppLogo';
import { BrightyAuthLayout } from './BrightyAuthLayout';
import { WolfoAuthLayout } from './WolfoAuthLayout';
import { AppLayout } from '../../Layout/AppLayout';

export function AuthLayout({ children }: { children: React.ReactNode }) {
  if (__BRIGHTY__) {
    return <BrightyAuthLayout>{children}</BrightyAuthLayout>;
  }

  if (__WOLFO__) {
    return <WolfoAuthLayout>{children}</WolfoAuthLayout>;
  }

  return (
    <AppLayout>
      <Stack width="100%" height="100%" paddingX={2} paddingY={8}>
        <Stack direction="row" justifyContent="start" width="100%">
          <ButtonBase href="/">
            <AppLogo size={40} />
          </ButtonBase>
        </Stack>
        <Stack width="100%" height="100%" alignItems="center" justifyContent="center">
          {children}
        </Stack>
      </Stack>
    </AppLayout>
  );
}
